
function htmlImages(content, baseImgUrl, maxExternalImages) {
  var externalImagesCount = 0;

  return content

    // replace image links to <img/> tags
    .replace(/"[^"]*"|(https?:\/\/[^\/\s]+\/\S+\.(?:gif|jpe?g|tiff|png|svg|webp))\b/gi, function(pattern, match, i, full) {
      if (!match) return pattern;
      externalImagesCount++;
      return externalImagesCount <= maxExternalImages ? '<a href="' + match + '" target="_blank"><img src="' + match + '" alt="" /></a>' : match;
    })

    // if it's a mongoid, eg: 5a328e37f2fc5923f6f33787.jpg
    .replace(/(?!")([a-z0-9]{24}\.(?:gif|jpg|jpeg|tiff|png|svg|webp))(?!")/gi,
       '<a href="' + baseImgUrl + '/file/$1" target="_blank"><img src="' + baseImgUrl + '/file/$1" alt="" /></a>'
    )
  ;
}

function htmlContent(content, parseLinks) {
  return content

    // code blocks
    .replace(/`{3}(<br \/>)?([\s\S]*?)`{3}(<br \/>)?/gm, '<pre>$2</pre>')
    .replace(/`([\s\S]*?)`/gm, '<code>$1</code>')

    // Replace the div by br
    .replace(/<div>/g, '')
    .replace(/<\/div>/g, '<br />')

    // Replace all the &lt;br/&gt; and \n by <br/> (\h : horizontal whitespace)
      //(\h*((&lt;br\h{0,1}\/{0,1}\h{0,1}&gt;)|(\r\n|\n|\r))\h*)
    .replace(/((&lt;br\h{0,1}\/{0,1}\h{0,1}&gt;)|(\r\n|\n|\r))/g, '<br />')

    // Allow at max two br
    .replace(/(\s*<br\s*\/>){3,}/g, '<br /><br />')
    .replace(/&nbsp;/g, '')

    // remove links with 'href' attribute
    .replace(/<a(?![^>]+href).*?>(.*?)<\/a>/g, '$1')

    // parse links
    .replace(/$/, ' ') // fix regex below not matching if no empty space at the end
    .replace(
      /(https?:\/\/[^"<\s]+[^.<\s"()][-A-Za-z0-9+&@#\/%=~_|])(?![^<>]*>|[^"]*?<\/a)(?=\s|$)/gi,
      function(match, p1) {
        // if website.edition.link is disabled
        if (!parseLinks) return p1;

        // ignore images
        if (/(\.gif|jpg|jpeg|tiff|png|svg|webp)$/.test(p1)) return p1;

        return '<a href="' + p1 + '" class="gc-link" rel="nofollow" target="_blank">' + p1 + '</a>';
    })
  ;
}
